import { Link } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import SourceIcon from '@mui/icons-material/Source';
import { useSubscription } from '../common/SubscriptionsProvider';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import '../styles.css';


const NavBar = () => {

    const { activePlan } = useSubscription();
    const isActivePlan = activePlan.plan !== null && activePlan.plan !== undefined;
    const subscriptionExpired = activePlan.end_date !== null 
        && activePlan.end_date !== undefined 
        && new Date(activePlan.end_date) < new Date().toISOString();

    return (
        <nav>
        <div className="navbar-vertical" >
            {(isActivePlan && !subscriptionExpired) ? <div className='icon-wrapper'>
                <Link to='/spaces'>
                    <div className='icon-group'>
                        <div className='icon-custom'><SourceIcon fontSize='medium'/></div>
                         <p>Projects</p> 
                    </div>
                </Link>
            </div> : null }
            <div className='icon-wrapper'>
                <Link to='/profile'>
                    <div className='icon-group'>
                        <div className='icon-custom'><AccountCircleIcon fontSize='medium'/></div>
                            <p>Profile</p>
                    </div>
                </Link>
            </div>
            <div className='icon-wrapper'>
                <Link to='/plans'>
                    <div className='icon-group'>
                        <div className='icon-custom'><LocalOfferIcon fontSize='medium'/></div>
                            <p>Plans</p>
                    </div>
                </Link>
            </div>
            <div className='icon-wrapper'>
                <Link to='/logout'>
                    <div className='icon-group'>
                        <div className='icon-custom'><LogoutIcon fontSize='medium'/></div>
                         <p>Logout</p> 
                    </div>
                </Link>
            </div>
            </div>
        </nav>
    )

}

export default NavBar;